<template>
    <div id="app">
        <el-container>
            <el-header v-show="showHeader()">
                <dashboard-header />
            </el-header>
            <el-main>
                <div class="page-container" v-cloak>
                    <router-view/>
                </div>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    /* eslint-disable no-console,no-underscore-dangle,no-new,no-unused-vars,no-unreachable */
    import Vue from 'vue';
    import Router from 'vue-router';
    import ElementUI from 'element-ui';
    import { mapGetters } from 'vuex';
    import locale from 'element-ui/lib/locale/lang/de';
    import 'element-ui/lib/theme-chalk/index.css';
    import api from './util/api';
    import interceptor from './util/interceptor';
    import { AUTH } from './store/types';

    // Components
    import DashboardHeader from './components/global/header';

    Vue.use(Router);
    Vue.use(ElementUI, { locale });
    // in ms
    const userCheckTime = 900000;

    export default {
        name: 'App',
        components: { DashboardHeader },
        computed: {
            ...mapGetters(['get_current_user']),
        },
        methods: {
            showHeader () {
                // Hide header for login route
                return this.$route && this.$route.name !== 'login';
            },
        },
        created () {
            api.init();
            interceptor({ store: this.$store, router: this.$router });

            setInterval(() => {
                // Check if token is expired
                if (this.get_current_user) {
                    this.$store.dispatch(`${AUTH.namespace}${AUTH.CURRENT_USER}`);
                }
            }, userCheckTime);
        },
    };
</script>

<style lang="scss">
    body {
        background: #fefefe;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
    }

    .el-header {
        border-bottom: 1px solid #e6e6e6;
        box-shadow: 0 0 10px rgba(0, 0, 0, .12);
        height: 61px !important;
    }

    .el-row {
        margin-bottom: 20px;
    }

    .page-container {
        max-width: 1140px;
        margin: 50px auto;
    }

    // Global Styles are imported here:
    @import 'assets/scss/generic/_variables.scss';
    @import 'assets/scss/generic/_mixins.scss';
    @import 'assets/scss/generic/_reset.scss';
    @import 'assets/scss/generic/_globals.scss';
    @import 'assets/scss/generic/_transitions.scss';
    @import 'assets/scss/generic/_typo.scss';

    // Component Specific Styles are defined in their specific *.vue files
</style>



// WEBPACK FOOTER //
// src/App.vue